<template>
  <v-dialog v-model="isOpenPermissionRemove" max-width="300" persistent>
    <v-card>
      <v-card-title class="headline pa-4">
        {{ 'Eliminar registro' }}
      </v-card-title>
      <v-card-text class="pa-4 text-center">
        ¿Está seguro que desea eliminar el registro?
      </v-card-text>
      <v-card-actions class="pa-4 text-center">
        <v-row dense>
          <v-col cols="6">
            <v-btn
              @click="close()"
              :disabled="loading"
              color="primary"
              text
              block
            >
              {{ $t('actions.cancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="submit()"
              :loading="loading"
              color="primary"
              block
            >
              {{ $t('actions.accept') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

const defaultData = ({
  loading: false
})

export default {
  name: 'PermissionRemove',
  data: () => defaultData,
  computed: {
    ...mapGetters({
      isOpenPermissionRemove: 'permissions/isOpenPermissionRemove',
      permission: 'permissions/permission'
    })
  },
  methods: {
    ...mapActions({
      removePermission: 'permissions/removePermission'
    }),
    ...mapMutations({
      togglePermissionRemove: 'permissions/togglePermissionRemove',
      setPermission: 'permissions/setPermission'
    }),
    async submit () {
      const { permission, removePermission } = this
      const { id } = permission
      this.loading = true
      await removePermission({ id })
      this.loading = false
      this.close()
    },
    setDefaultData () {
      for (const key in defaultData) {
        this[key] = defaultData[key]
      }
    },
    cleanData () {
      this.setDefaultData()
      this.setPermission()
    },
    close () {
      this.togglePermissionRemove()
      setTimeout(() => this.cleanData(), 500)
    }
  }
}
</script>
